// A blocked subscription is not a load failure — it needs its own copy and a way forward.
// `locked` drives the CTA: View Plans vs Try Again.
export const toFetchError = (err) => {
  const code = err?.response?.data?.error?.code

  if (code === 'TRIAL_EXPIRED') {
    return { locked: true, title: 'Your free trial has ended.', body: 'Select a plan to keep analyzing deals.' }
  }
  if (code === 'SUBSCRIPTION_REQUIRED') {
    return { locked: true, title: 'Your subscription has expired.', body: 'Reactivate to keep analyzing deals.' }
  }
  return { locked: false, title: 'Unable to load properties.', body: 'Something went wrong on our side.' }
}

export default toFetchError
